import { AxiosError } from 'axios'
import { ApiBase } from './ApiBase'

export type ShareLinkStatus = 'active' | 'expired' | 'revoked' | 'disabled'

export interface IShareLinkEvent {
  event: string
  reason?: string | null
  result_set_id?: number | null
  user_agent?: string | null
  created_at: string
}

// a shared link of a template (external creation of processes without login)
export interface IShareLink {
  id: number
  label: string | null
  status: ShareLinkStatus
  expires_at: string | null
  revoked_at: string | null
  created_at: string
  uses_count: number
  last_used_at: string | null
  rejected_count: number
  last_rejected_at: string | null
  url: string
  long_url: string
  embed_url: string
  created_by_name: string | null
  revoked_by_name: string | null
  events: IShareLinkEvent[]
}

export interface IShareLinkData {
  label?: string | null
  expires_at?: string | null
}

// response of the backend when a shared link can't be used (anymore)
export interface IShareLinkError {
  share_link_error: 'expired' | 'revoked' | 'disabled' | 'unknown'
  expires_at?: string | null
  corporation_name?: string | null
  corporation_logo_url?: string | null
}

export const MAX_ACTIVE_SHARE_LINKS = 10

export function getShareLinkError(error: any): IShareLinkError | null {
  const data = (error as AxiosError)?.response?.data as any
  return data?.share_link_error ? data as IShareLinkError : null
}

export class ShareLinksApi extends ApiBase {
  public async all(checklistId: number): Promise<IShareLink[]> {
    const response = await this.get<IShareLink[]>(`/checklists/${checklistId}/share_links`)
    return response.data
  }

  public async create(checklistId: number, data: IShareLinkData): Promise<IShareLink> {
    const response = await this.post<IShareLink>(`/checklists/${checklistId}/share_links`, data)
    return response.data
  }

  public async update(checklistId: number, id: number, data: IShareLinkData): Promise<IShareLink> {
    const response = await this.put<IShareLink>(`/checklists/${checklistId}/share_links/${id}`, data)
    return response.data
  }

  // deactivates the link immediately
  public async revoke(checklistId: number, id: number): Promise<IShareLink> {
    const response = await this.delete<IShareLink>(`/checklists/${checklistId}/share_links/${id}`)
    return response.data
  }
}
